import React from "react";

import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';

const useStyles = makeStyles((theme) => ({
    form: {
        margin: theme.spacing(1),
    },
    field: {
        width: '25ch',
        maxWidth: '100%',
    },
}));

export const InputForm = ({ inputValue, handleChange, handleSubmit, hText, name }) => {

    const classes = useStyles();

    return (
        <form className={classes.form} onSubmit={handleSubmit} noValidate autoComplete="off">
            <TextField
                className={classes.field}
                type="number"
                size="small"
                variant="outlined"
                label={hText}
                value={inputValue}
                onChange={handleChange}
                name={name ? name : undefined}
            />
        </form>
    )
}
